// El dato con el que la pasarela encuentra un pago en SU panel. En Line es el
// `IdentificadorCliente` (un UUID), que no coincide con el id de pago
// (`pay_…`) ni con el n.º de operacion: es lo que pide el operador de Line
// para revertir un pago. Se muestra completo, porque se dicta y se pega en un
// buscador que no acepta abreviaturas.

import { CopyButton } from '@/components/DataCard';

const PROVIDER_LABEL: Record<string, string> = {
  line: 'Line',
  mercadopago: 'Mercado Pago',
  stripe: 'Stripe',
};

export function providerLookupLabel(provider: string | null | undefined): string {
  return `ID en ${PROVIDER_LABEL[provider ?? ''] ?? 'la pasarela'}`;
}

export default function ProviderLookupId({
  id,
  provider,
  showMissing = false,
}: {
  id: string | null | undefined;
  provider: string | null | undefined;
  /** Si no hay dato, decirlo en vez de no mostrar nada (donde hace falta para reintegrar). */
  showMissing?: boolean;
}): JSX.Element | null {
  const label = providerLookupLabel(provider);
  if (!id) {
    if (!showMissing) return null;
    return (
      <span
        className="text-xs text-ink-subtle"
        title="Se completa la próxima vez que se consulta el pago a la pasarela (botón «Reconciliar pago»)."
      >
        {label}: todavía no disponible
      </span>
    );
  }
  return (
    <span
      data-help="payments.lookup-id"
      className="inline-flex items-center gap-0.5 text-xs"
      title={`${label}: con este dato se encuentra el pago en el panel de la pasarela`}
    >
      <span className="text-ink-muted">{label}:</span>{' '}
      <span className="font-mono">{id}</span>
      <CopyButton value={id} label={label} />
    </span>
  );
}
